import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Zap, Scale, TrendingDown } from 'lucide-react';
const costData = [{
  without: 'Sin negociación',
  cost: 'Pagás entre $100.000 y $300.000 más de lo que vale'
}, {
  without: 'Sin detección de km adulterado',
  cost: 'Comprás 180.000 km creyendo que tiene 80.000'
}, {
  without: 'Sin verificación documental',
  cost: 'Heredás deudas o una prenda activa'
}, {
  without: 'Sin sistema de inspección',
  cost: 'El vendedor sabía el problema. Vos no.'
}];
export function CostTable() {
  return <section className="py-16 bg-graphite relative overflow-hidden" data-id="element-120">
      <div className="absolute top-0 left-0 w-full h-2 hazard-tape" data-id="element-121"></div>
      <div className="absolute bottom-0 left-0 w-full h-2 hazard-tape" data-id="element-122"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-electric/5 blur-[120px] rounded-full pointer-events-none" data-id="element-123"></div>

      <div className="container mx-auto px-4 relative z-10 mt-4" data-id="element-124">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-125">
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-red-400 to-electric rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-126"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20 bg-brushed" data-id="element-127">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(217,30,24,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(217,30,24,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-128"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-129"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-130"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-131"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-132"></div>

            <div className="relative z-10" data-id="element-133">
              <div className="inline-flex items-center gap-2 bg-electric text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-134">
                <Scale className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-135" />
                El costo real
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-136">
                <span className="text-white" data-id="element-137">¿Cuánto cuesta </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-red-400 to-electric drop-shadow-[0_0_12px_rgba(217,30,24,0.4)]" data-id="element-138">
                  no tenerlo?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-139"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop table */}
        <div className="max-w-3xl mx-auto mb-10 hidden md:block" data-id="element-140">
          <div className="bg-gradient-to-br from-petroleum to-graphite border border-electric/25 rounded-2xl overflow-hidden shadow-xl shadow-electric/5" data-id="element-141">
            <table className="w-full text-left border-collapse" data-id="element-142">
              <thead data-id="element-143">
                <tr className="bg-graphite/70" data-id="element-144">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest" data-id="element-145">
                    <span className="inline-flex items-center gap-2" data-id="element-146">
                      <span className="w-6 h-6 rounded-md bg-white/5 flex items-center justify-center" data-id="element-147">
                        <TrendingDown className="w-3.5 h-3.5" data-id="element-148" />
                      </span>
                      Sin el Protocolo
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-electric/40 text-electric font-extrabold text-xs uppercase tracking-widest bg-electric/5" data-id="element-149">
                    <span className="inline-flex items-center gap-2" data-id="element-150">
                      <span className="w-6 h-6 rounded-md bg-electric/20 flex items-center justify-center" data-id="element-151">
                        <AlertTriangle className="w-3.5 h-3.5" data-id="element-152" />
                      </span>
                      Costo real
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-153">
                {costData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-154">
                    <td className="p-5 text-white font-medium align-top" data-id="element-155">
                      <span className="inline-flex items-start gap-3" data-id="element-156">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-157">
                          {i + 1}
                        </span>
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-white font-semibold align-top bg-electric/[0.04] group-hover:bg-electric/[0.08] transition-colors border-l border-electric/20" data-id="element-158">
                      <span className="inline-flex items-start gap-2" data-id="element-159">
                        <AlertTriangle className="w-4 h-4 text-electric shrink-0 mt-0.5" data-id="element-160" />
                        {row.cost}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-3" data-id="element-161">
          {costData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-gradient-to-br from-petroleum to-graphite border border-electric/20 rounded-2xl overflow-hidden shadow-lg" data-id="element-162">
              <div className="px-5 py-3 bg-graphite/60 border-b border-white/10 flex items-center gap-2.5" data-id="element-163">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center" data-id="element-164">
                  {i + 1}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-165">
                  {row.without}
                </p>
              </div>
              <div className="px-5 py-4 bg-electric/[0.06]" data-id="element-166">
                <div className="inline-flex items-center gap-1.5 text-electric text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-167">
                  <AlertTriangle className="w-3 h-3" data-id="element-168" /> Costo real
                </div>
                <p className="text-white text-sm font-semibold" data-id="element-169">{row.cost}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing quote card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto" data-id="element-170">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-gold/40 via-yellow-300/30 to-gold/40 rounded-2xl blur-lg opacity-40" data-id="element-171"></div>
          <div className="relative bg-gradient-to-br from-petroleum to-graphite border border-gold/40 rounded-2xl p-8 text-center shadow-[0_0_30px_rgba(255,193,7,0.12)]" data-id="element-172">
            <h3 className="text-xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 leading-snug flex items-center justify-center gap-3 flex-wrap" data-id="element-173">
              <Zap className="w-6 h-6 md:w-7 md:h-7 text-gold fill-gold drop-shadow-[0_0_8px_rgba(255,193,7,0.6)]" data-id="element-174" />
              <span data-id="element-175">
                "El próximo auto que veas puede ser el primero que evaluás con
                un sistema que te proteja."
              </span>
            </h3>
            <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-60" data-id="element-176"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}